import CTAButton from '../general/CTAButton';
import useIsMobile from '../../utils/hooks/useIsMobile';
import s from '../../styles/components/home/Experience.module.css';

export default function Experience({ data }) {
  const { sectionTitle, sectionSubheader, tiles, cta } = data;
  const isMobile = useIsMobile();

  const layout = [
    { id: 1, size: 'large', col: 1, row: 1 },
    { id: 2, size: 'small', col: 3, row: 1 },
    { id: 3, size: 'small', col: 4, row: 1 },
    { id: 4, size: 'wide',  col: 3, row: 2 },
    { id: 5, size: 'small', col: 1, row: 3 },
    { id: 6, size: 'small', col: 2, row: 3 },
    { id: 7, size: 'small', col: 3, row: 3 },
    { id: 8, size: 'small', col: 4, row: 3 },
  ];

  const layoutWithImages = layout.map(entry => {
    const tile = tiles.find(t => t.id === entry.id);
    return { ...entry, image: tile.image };
  });

  const loopTiles = [...layoutWithImages, ...layoutWithImages];

  return (
    <section className={s.container}>
      <div className={isMobile ? s.frameMobile : s.frame}>
      <div className={isMobile ? s.textColMobile : s.textCol}>
          <h2 className={s.title}>{sectionTitle}</h2>
          <p className={s.subheader}>{sectionSubheader}</p>
          <div className={s.ctaRow}>
            <CTAButton label={cta.label} url={cta.url} />
          </div>
        </div>

        <div className={isMobile ? s.gridWrapperMobile : s.gridWrapper}>
          <div className={`${s.grid} experience-grid-drift`}>
            {loopTiles.map((tile, i) => {
              const isDuplicate = i >= layoutWithImages.length;
              const colOffset = isDuplicate ? 4 : 0;
              return (
                <div
                  key={`${tile.id}-${i}`}
                  className={`${s.tileBase} ${s[tile.size]}`}
                  style={{
                    gridColumn: `${tile.col + colOffset} / span ${tile.size === 'large' || tile.size === 'wide' || tile.size === 'medium' ? 2 : 1}`,
                    gridRow: `${tile.row} / span ${tile.size === 'large' ? 2 : 1}`,
                  }}
                >
                  <img src={tile.image} alt="" className={s.image} />
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}